/**
 * @generated SignedSource<<502ac36e1815487fff9a953caed897ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RouteConfig_ProjectOverviewPage_Query$variables = {
  studyId: string;
};
export type RouteConfig_ProjectOverviewPage_Query$data = {
  readonly viewer: {
    readonly study: {
      readonly " $fragmentSpreads": FragmentRefs<"ProjectOverviewPage_study">;
    } | null;
  };
};
export type RouteConfig_ProjectOverviewPage_Query = {
  response: RouteConfig_ProjectOverviewPage_Query$data;
  variables: RouteConfig_ProjectOverviewPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "studyId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "studyId",
    "variableName": "studyId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qualified",
  "storageKey": null
},
v8 = [
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "labeledText",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dbId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qualifiedTotal",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "terminate",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quota",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalPayouts",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "goalPaidForCount",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalDeposits",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalRefunds",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalRefundsDue",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RouteConfig_ProjectOverviewPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProjectOverviewPage_study"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RouteConfig_ProjectOverviewPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "scheduled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TenantNode",
                "kind": "LinkedField",
                "name": "tenant",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vpmAccountId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requireStudyPayment",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FieldReportNode",
                "kind": "LinkedField",
                "name": "fieldReport",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ResponseSummaryNode",
                    "kind": "LinkedField",
                    "name": "responseSummary",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TotalQualedNode",
                        "kind": "LinkedField",
                        "name": "totalStarts",
                        "plural": false,
                        "selections": (v8/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TotalQualedNode",
                        "kind": "LinkedField",
                        "name": "screenerDropouts",
                        "plural": false,
                        "selections": (v8/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TotalQualedNode",
                        "kind": "LinkedField",
                        "name": "screenerTermed",
                        "plural": false,
                        "selections": (v8/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TotalQualedNode",
                        "kind": "LinkedField",
                        "name": "screenerQualified",
                        "plural": false,
                        "selections": (v8/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TotalQualedNode",
                        "kind": "LinkedField",
                        "name": "totalNeeded",
                        "plural": false,
                        "selections": (v8/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TotalQualedNode",
                        "kind": "LinkedField",
                        "name": "rsvpAccepted",
                        "plural": false,
                        "selections": (v8/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TotalQualedNode",
                        "kind": "LinkedField",
                        "name": "rsvpDeclined",
                        "plural": false,
                        "selections": (v8/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TotalQualedNode",
                        "kind": "LinkedField",
                        "name": "rsvpMaybe",
                        "plural": false,
                        "selections": (v8/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FieldReportElementNode",
                    "kind": "LinkedField",
                    "name": "elements",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FieldReportRowNode",
                        "kind": "LinkedField",
                        "name": "rows",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FieldReportRowOptionNode",
                            "kind": "LinkedField",
                            "name": "options",
                            "plural": true,
                            "selections": [
                              (v11/*: any*/),
                              (v9/*: any*/),
                              (v7/*: any*/),
                              (v12/*: any*/),
                              (v6/*: any*/),
                              (v13/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FieldReportOptionNode",
                        "kind": "LinkedField",
                        "name": "options",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          (v7/*: any*/),
                          (v12/*: any*/),
                          (v6/*: any*/),
                          (v14/*: any*/),
                          (v13/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FieldReportGridAnswerNode",
                        "kind": "LinkedField",
                        "name": "gridAnswers",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rowId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "answerId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "goal",
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "label",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FieldReportSegmentNode",
                    "kind": "LinkedField",
                    "name": "segments",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FieldReportSegmentRowNode",
                        "kind": "LinkedField",
                        "name": "rows",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          (v14/*: any*/),
                          (v13/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "overQuota",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "terminants",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalSpend",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "incentiveType",
                "storageKey": null
              },
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalBaseCosts",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalFees",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalPerParticipantCosts",
                "storageKey": null
              },
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitNodeConnection",
                "kind": "LinkedField",
                "name": "recruits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecruitNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RecruitNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "participantBaseCost",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fee",
                            "storageKey": null
                          },
                          (v17/*: any*/),
                          (v15/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cd119b6fec499fd39735cdf380216dbf",
    "id": null,
    "metadata": {},
    "name": "RouteConfig_ProjectOverviewPage_Query",
    "operationKind": "query",
    "text": "query RouteConfig_ProjectOverviewPage_Query(\n  $studyId: String!\n) {\n  viewer {\n    study(studyId: $studyId) {\n      ...ProjectOverviewPage_study\n      id\n    }\n  }\n}\n\nfragment ExportFieldReportButton_study on StudyNode {\n  dId\n  tenant {\n    dId\n    vpmAccountId\n    name\n    id\n  }\n  name\n  type\n  status\n}\n\nfragment ExportSpendingDetailsButton_study on StudyNode {\n  dId\n  tenant {\n    name\n    dId\n    vpmAccountId\n    id\n  }\n  name\n  type\n  status\n}\n\nfragment FieldReportQuestionTable_element on FieldReportElementNode {\n  text\n  type\n  labeledText\n  rows {\n    dbId\n    text\n    labeledText\n    options {\n      dbId\n      text\n      qualified\n      qualifiedTotal\n      total\n    }\n    id\n  }\n  options {\n    text\n    qualified\n    qualifiedTotal\n    total\n    quota\n    terminate\n  }\n  gridAnswers {\n    rowId\n    answerId\n    goal\n    terminate\n    id\n  }\n}\n\nfragment FieldReportSegmentTable_segments on FieldReportSegmentNode {\n  rows {\n    text\n    quota\n    terminate\n    qualified\n    overQuota\n    terminants\n  }\n}\n\nfragment ProjectFieldReport_study on StudyNode {\n  dId\n  tenant {\n    name\n    id\n  }\n  fieldReport {\n    responseSummary {\n      ...ResponseSummaryTable_responseSummary\n    }\n    elements {\n      type\n      ...FieldReportQuestionTable_element\n    }\n    segments {\n      ...FieldReportSegmentTable_segments\n    }\n  }\n  ...ExportFieldReportButton_study\n}\n\nfragment ProjectOverviewPage_study on StudyNode {\n  id\n  name\n  scheduled\n  status\n  type\n  ...ProjectFieldReport_study\n  ...ProjectSpend_study\n  tenant {\n    requireStudyPayment\n    id\n  }\n  fieldReport {\n    responseSummary {\n      totalNeeded {\n        total\n      }\n      totalStarts {\n        qualified\n        total\n      }\n      screenerDropouts {\n        total\n      }\n    }\n    elements {\n      ...QuotasOverviewElementTable_element\n      ...TerminantsOverviewTable_element\n      text\n      type\n      options {\n        dbId\n        quota\n        terminate\n        total\n      }\n      rows {\n        dbId\n        options {\n          dbId\n          total\n          terminate\n        }\n        id\n      }\n      gridAnswers {\n        rowId\n        answerId\n        terminate\n        id\n      }\n    }\n  }\n}\n\nfragment ProjectSpend_study on StudyNode {\n  totalPayouts\n  totalSpend\n  ...SpendingDetails_study\n}\n\nfragment QuotasOverviewElementTable_element on FieldReportElementNode {\n  text\n  type\n  label\n  labeledText\n  options {\n    text\n    qualified\n    qualifiedTotal\n    total\n    quota\n    terminate\n  }\n}\n\nfragment ResponseSummaryTable_responseSummary on ResponseSummaryNode {\n  totalStarts {\n    total\n    qualified\n  }\n  screenerDropouts {\n    total\n    qualified\n  }\n  screenerTermed {\n    total\n    qualified\n  }\n  screenerQualified {\n    total\n    qualified\n  }\n  totalNeeded {\n    total\n    qualified\n  }\n  rsvpAccepted {\n    total\n    qualified\n  }\n  rsvpDeclined {\n    total\n    qualified\n  }\n  rsvpMaybe {\n    total\n    qualified\n  }\n}\n\nfragment SpendingDetails_study on StudyNode {\n  dId\n  status\n  incentiveType\n  tenant {\n    name\n    id\n  }\n  goalPaidForCount\n  totalBaseCosts\n  totalFees\n  totalPerParticipantCosts\n  totalDeposits\n  totalPayouts\n  totalRefunds\n  totalRefundsDue\n  recruits {\n    edges {\n      node {\n        name\n        goalPaidForCount\n        participantBaseCost\n        fee\n        totalDeposits\n        totalPayouts\n        totalRefunds\n        totalRefundsDue\n        id\n      }\n    }\n  }\n  ...ExportSpendingDetailsButton_study\n}\n\nfragment TerminantsOverviewTable_element on FieldReportElementNode {\n  text\n  type\n  label\n  labeledText\n  rows {\n    dbId\n    text\n    options {\n      dbId\n      text\n      terminate\n      total\n    }\n    id\n  }\n  options {\n    text\n    qualified\n    qualifiedTotal\n    total\n    quota\n    terminate\n  }\n  gridAnswers {\n    rowId\n    answerId\n    terminate\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "79571be809b82f6d9064b87f9f2664f5";

export default node;
